import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    containerPaginationAndAgentCard: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    wrapperAgentCourse: {
      display: "flex",
      flexDirection: "column",
      gap: "24px",
    },
    containerCardsAgentsCourse: {
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      flexWrap: "wrap",
    },
  };
});
